var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "trans_SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.1188,
    y1: 190.6627,
    x2: 254.1188,
    y2: 514.7917,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#trans_SVGID_1_)"
    },
    cx: 255.308,
    cy: 256,
    r: 160.306
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trans_SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.1188,
    y1: 325.0128,
    x2: 254.1188,
    y2: 16.9127,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#trans_SVGID_2_)"
    },
    cx: 255.308,
    cy: 256,
    r: 152.375
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trans_SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.6788,
    y1: 203.9827,
    x2: 122.3888,
    y2: 391.2728,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#trans_SVGID_3_)"
    },
    cx: 255.308,
    cy: 256,
    r: 122.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trans_SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.3074,
    y1: 181.2602,
    x2: 138.3274,
    y2: 313.3202,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE600",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#trans_SVGID_4_)"
    },
    d: "M378.097,262.26l-76.564-76.564c-1.702-2.964-5.236-5.411-10.61-7.344  c-5.515-1.979-11.392-3.326-17.618-4.069l-8.222-7.335c-0.165-1.16-0.844-2.212-2.105-3.141c-1.453-1.066-3.017-1.603-4.694-1.603  c-1.832,0-3.4,0.537-4.696,1.603c-1.299,1.07-1.947,2.291-1.947,3.664v6.643c-12.369,1.374-22.715,5.496-31.036,12.368  c-8.325,6.872-12.484,16.942-12.484,30.206c0,4.724,0.533,9.029,1.603,12.916c1.067,3.886,2.824,7.276,5.269,10.172  c2.441,2.895,4.771,5.372,6.985,7.43c0.117,0.109,0.248,0.218,0.371,0.326l29.291,29.358v38.319  c-6.767-0.458-12.726-2.208-17.881-5.258c-5.153-3.045-9.201-5.901-12.149-8.571c-2.95-2.666-5.329-4.002-7.14-4.002  c-2.735,0-5.161,1.45-7.287,4.344c-2.125,2.895-3.185,5.791-3.185,8.686c0,4.746,2.753,9.421,8.237,14.027l54.022,54.022  C326.975,373.098,375.02,323.608,378.097,262.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB92D"
    },
    d: "M203.997,310.409c0-2.895,1.06-5.791,3.185-8.686c2.125-2.895,4.553-4.344,7.287-4.344  c1.81,0,4.19,1.334,7.14,4.001c2.949,2.669,6.996,5.526,12.149,8.571c5.154,3.049,11.113,4.8,17.881,5.258v-53.716  c-4.58-1.675-8.096-3.01-10.535-4.002c-2.445-0.988-5.691-2.438-9.736-4.341c-4.047-1.904-7.178-3.886-9.391-5.944  c-2.215-2.058-4.545-4.535-6.985-7.43c-2.446-2.895-4.201-6.285-5.269-10.172c-1.07-3.886-1.603-8.192-1.603-12.916  c0-13.264,4.159-23.334,12.484-30.206c8.32-6.872,18.667-10.994,31.036-12.368v-6.643c0-1.374,0.648-2.594,1.947-3.664  c1.296-1.066,2.863-1.603,4.696-1.603c1.678,0,3.243,0.537,4.694,1.603c1.45,1.07,2.177,2.291,2.177,3.664v6.184  c9.312,0.307,17.903,1.872,25.769,4.695c7.864,2.827,11.796,6.756,11.796,11.796c0,2.749-0.927,5.612-2.773,8.59  c-1.846,2.978-4.313,4.466-7.391,4.466c-1.217,0-4.563-1.296-10.031-3.894c-5.473-2.595-11.263-4.123-17.37-4.581v46.418  c6.074,2.287,11.124,4.459,15.146,6.516c4.023,2.058,8.278,4.914,12.759,8.571c4.481,3.657,7.86,8.267,10.137,13.829  c2.276,5.562,3.417,12.078,3.417,19.544c0,13.642-3.722,24.487-11.163,32.532c-7.444,8.045-17.541,12.988-30.295,14.827v7.652  c0,1.349-0.726,2.548-2.177,3.6c-1.453,1.049-3.017,1.575-4.694,1.575c-1.832,0-3.4-0.526-4.696-1.571  c-1.299-1.052-1.947-2.251-1.947-3.6v-6.968c-13.285-0.154-24.548-3.192-33.785-9.119  C208.615,322.61,203.997,316.568,203.997,310.409z M230.797,214.406c0,5.944,1.85,10.479,5.554,13.6  c3.7,3.124,9.256,6.059,16.663,8.8v-41.64C238.201,196.998,230.797,203.411,230.797,214.406z M263.78,314.751  c13.436-2.438,20.157-9.982,20.157-22.629c0-6.703-1.758-11.961-5.269-15.769c-3.514-3.808-8.474-7.086-14.888-9.831L263.78,314.751  L263.78,314.751z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trans_SVGID_5_",
    cx: 251.5788,
    cy: 261.3127,
    r: 253.3692,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A2F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    style: {
      stopColor: "#03A4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    style: {
      stopColor: "#0CAAF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#1BB4F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    style: {
      stopColor: "#31C2F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#4DD4F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62E1FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#trans_SVGID_5_)"
    },
    d: "M497.248,116.044c-10.356-3.789-21.691,0.536-27.079,9.726  c-16.986-28.038-39.411-52.569-66.422-72.39C360.464,21.622,309.134,4.836,255.305,4.836S150.145,21.622,106.863,53.38  c-42.391,31.104-73.507,73.8-89.986,123.468c-3.907,11.777,2.473,24.492,14.25,28.399c11.781,3.909,24.493-2.473,28.399-14.25  c13.527-40.771,39.088-75.831,73.92-101.389c35.52-26.063,77.657-39.84,121.859-39.84s86.338,13.777,121.859,39.841  c20.744,15.22,38.198,33.812,51.781,54.972c-10.336-1.553-20.685,4.307-24.416,14.505c-4.265,11.653,1.726,24.556,13.379,28.82  l46.781,17.117c0.112,0.041,0.226,0.068,0.338,0.107c0.393,0.137,0.789,0.261,1.189,0.376c0.214,0.061,0.427,0.124,0.641,0.18  c0.404,0.103,0.811,0.19,1.221,0.271c0.209,0.041,0.418,0.089,0.626,0.124c0.435,0.073,0.873,0.124,1.314,0.173  c0.179,0.019,0.358,0.049,0.537,0.063c0.613,0.051,1.23,0.08,1.85,0.08c0,0,0,0,0.001,0h0.001c0.583,0,1.164-0.024,1.74-0.069  c0.138-0.011,0.275-0.034,0.413-0.047c0.444-0.043,0.887-0.089,1.326-0.159c0.17-0.027,0.339-0.067,0.51-0.098  c0.409-0.074,0.816-0.151,1.219-0.247c0.189-0.045,0.376-0.103,0.565-0.154c0.382-0.101,0.761-0.205,1.135-0.326  c0.056-0.018,0.112-0.03,0.169-0.048c0.111-0.037,0.215-0.088,0.326-0.126c0.495-0.174,0.984-0.362,1.466-0.569  c0.207-0.088,0.413-0.177,0.615-0.271c0.47-0.219,0.931-0.456,1.385-0.707c0.144-0.079,0.294-0.15,0.436-0.232  c0.546-0.317,1.076-0.664,1.595-1.027c0.203-0.142,0.396-0.293,0.592-0.441c0.346-0.26,0.686-0.528,1.018-0.808  c0.182-0.154,0.362-0.308,0.539-0.468c0.378-0.341,0.744-0.697,1.099-1.064c0.098-0.102,0.204-0.199,0.3-0.303  c0.463-0.497,0.906-1.017,1.325-1.559c0.029-0.038,0.055-0.078,0.084-0.116c0.373-0.49,0.727-1,1.062-1.525  c0.089-0.141,0.174-0.284,0.26-0.427c0.259-0.426,0.504-0.861,0.737-1.308c0.095-0.184,0.191-0.367,0.281-0.554  c0.203-0.419,0.39-0.847,0.569-1.283c0.083-0.202,0.172-0.401,0.249-0.605c0.026-0.07,0.059-0.137,0.085-0.208l17.118-46.781  C514.89,133.212,508.9,120.308,497.248,116.044z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trans_SVGID_6_",
    cx: 169.1916,
    cy: 805.9628,
    r: 253.3718,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 429.1081 -551.3407)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    style: {
      stopColor: "#C14046"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    style: {
      stopColor: "#CA4148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    style: {
      stopColor: "#D9444B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    style: {
      stopColor: "#EF4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4C54"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#trans_SVGID_6_)"
    },
    d: "M14.753,395.955c10.356,3.789,21.691-0.536,27.079-9.726  c16.986,28.038,39.411,52.569,66.422,72.39c43.282,31.758,94.613,48.546,148.442,48.546s105.16-16.787,148.442-48.546  c42.391-31.104,73.507-73.799,89.987-123.468c3.907-11.777-2.473-24.492-14.25-28.399c-11.781-3.908-24.493,2.473-28.399,14.25  c-13.527,40.771-39.088,75.831-73.92,101.389c-35.52,26.063-77.657,39.84-121.859,39.84s-86.338-13.776-121.859-39.84  c-20.744-15.22-38.198-33.812-51.781-54.972c10.336,1.553,20.685-4.307,24.416-14.505c4.265-11.652-1.726-24.556-13.379-28.82  l-46.781-17.117c-0.112-0.041-0.226-0.068-0.338-0.107c-0.393-0.137-0.789-0.261-1.189-0.376c-0.214-0.061-0.427-0.124-0.641-0.18  c-0.404-0.103-0.811-0.19-1.221-0.271c-0.209-0.041-0.418-0.089-0.626-0.124c-0.435-0.073-0.873-0.124-1.314-0.173  c-0.179-0.019-0.358-0.049-0.537-0.063c-0.613-0.051-1.23-0.08-1.85-0.08c0,0,0,0-0.001,0h-0.001c-0.583,0-1.164,0.024-1.74,0.069  c-0.138,0.011-0.275,0.034-0.413,0.047c-0.444,0.043-0.887,0.089-1.326,0.159c-0.17,0.027-0.339,0.067-0.51,0.098  c-0.409,0.074-0.816,0.151-1.219,0.247c-0.189,0.045-0.376,0.103-0.565,0.154c-0.381,0.101-0.761,0.205-1.135,0.326  c-0.056,0.018-0.112,0.03-0.169,0.048c-0.111,0.037-0.215,0.088-0.326,0.126c-0.495,0.174-0.984,0.362-1.466,0.569  c-0.207,0.088-0.413,0.177-0.615,0.271c-0.47,0.219-0.931,0.456-1.385,0.707c-0.144,0.079-0.294,0.15-0.436,0.232  c-0.546,0.317-1.076,0.664-1.595,1.027c-0.203,0.142-0.396,0.293-0.592,0.441c-0.346,0.26-0.686,0.528-1.018,0.808  c-0.182,0.154-0.362,0.308-0.539,0.468c-0.378,0.341-0.744,0.697-1.099,1.064c-0.098,0.102-0.204,0.199-0.3,0.303  c-0.463,0.497-0.906,1.017-1.325,1.559c-0.029,0.038-0.055,0.078-0.084,0.116c-0.373,0.49-0.727,1-1.062,1.525  c-0.089,0.141-0.174,0.284-0.26,0.427c-0.259,0.426-0.504,0.861-0.737,1.308c-0.095,0.184-0.191,0.367-0.281,0.554  c-0.203,0.419-0.39,0.847-0.569,1.283c-0.083,0.202-0.172,0.401-0.249,0.605c-0.026,0.07-0.059,0.137-0.085,0.208L1.375,367.135  C-2.89,378.787,3.1,391.692,14.753,395.955z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.a8a70f4d977da51690a8f931b4b3dad2.svg";
export { ForwardRef as ReactComponent };